<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Changelog></Changelog>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Changelog from './changelog/Changelog'

export default {
  name: 'Newsbox',
  components: {Changelog},
  watch: {
    selected: function (value) {
      Vue.prototype.$api.debug('selected', value)
      this.selected = value
    }
  },
  data () {
    return {
      cellspan: 6,
      ankerBank: null,
      tabModel: 0,
      hasAnkerBank: false,
      emailSet: [
        {text: Vue.i18n.translate('EMAIL_JA'), id: '1'},
        {text: Vue.i18n.translate('EMAIL_NEIN'), id: '0'}
      ],
      //  Name, CrefoNr./HGP-Nr., Abschlussart, Rechtskreis, Jahr, Quelle, Datum, Änderungsgrund
      headers: [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr'},
        {text: Vue.i18n.translate('CELL_TITLE_ABSCHLUSS'), value: 'AbschlussartNr'},
        {text: Vue.i18n.translate('CELL_TITLE_RECHTSKREIS'), value: 'rk'},
        {text: Vue.i18n.translate('CELL_TITLE_JAHR'), value: 'Jahr'},
        {text: Vue.i18n.translate('CELL_TITLE_QUELLE'), value: 'QuelleNr'},
        {text: Vue.i18n.translate('CELL_TITLE_DATUM'), value: 'datumZeit'},
        {text: Vue.i18n.translate('CELL_TITLE_GRUND'), value: 'Aenderungsgrund'}
      ],
      // Name, CrefoNr./HGP-Nr., Region, Land, E-Mail-Benachrichtigung (an/aus)
      headersBL: [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr'},
        {text: Vue.i18n.translate('CELL_TITLE_REGION'), value: 'region'},
        {text: Vue.i18n.translate('CELL_TITLE_LAND'), value: 'country'},
        {text: Vue.i18n.translate('CELL_TITLE_DATUM'), value: 'datumZeit'},
        {text: Vue.i18n.translate('CELL_TITLE_BRANCHE'), value: 'branch'},
        {text: Vue.i18n.translate('CELL_TITLE_ACTION'), value: 'action'}
      ],
      crefoDoubleExists: false,
      pagination: {
        rowsPerPage: 5000,
        descending: true,
        sortBy: 'year'
      },
      tableData: [],
      tableDataBL: [],
      countries: [],
      selected: []
    }
  },
  methods: {
    restart () {
      // window.location = '/rating/displayApplicationsOrApplicationAreas.php?AppNr=161'
      window.location = Vue.prototype.storage.appConfig.RESET_URL
    },
    /* Favoriten */
    onGetChangelogBL: function (data) {
      Vue.prototype.$api.debug('onGetChangelogBL', data)
      if (data.array === null) {
        data.array = []
      }
      this.tableDataBL = data.array
      for (var index in this.tableDataBL) {
        var item = this.tableDataBL[index]
        item.isEmail = item.email === '1'
        if (item.isEmail) {
          this.selected.push(item)
        }
      }
      Vue.prototype.$api.hideIdle()
    },
    showGroup (item) {
      if (item.diffText !== null) {
        return true
      }
      return false
    },
    toggleAll () {
      if (this.selected.length) {
        for (var index in this.selected) {
          var item = this.selected[index]
          this.setEmailNotification(item, false)
        }
        this.selected = []
      } else {
        this.selected = this.tableDataBL.slice()
        for (var index1 in this.selected) {
          var item1 = this.selected[index1]
          this.setEmailNotification(item1, true)
        }
      }
    },
    parseDate: function (dateStr) {
      var d = moment(dateStr)
      return d
    },
    /* Änderungen */
    onGetChangelogs: function (data) {
      Vue.prototype.$api.debug('onGetChangelogs', data)
      if (data.array === null) {
        data.array = []
      }
      this.tableData = data.array
      var current = new Date()
      var lastGroup = null
      for (var index in this.tableData) {
        var item = this.tableData[index]
        item.isEmail = item.email === '1'
        item.dayCount = this.dayDiff(moment(current), this.parseDate(item.datumZeit))
        var text = Vue.i18n.translate('TABLE_LINE_LATER')

        if (item.dayCount <= 30) {
          text = Vue.i18n.translate('TABLE_LINE_LAST_MONTH')
        }
        if (item.dayCount <= 7) {
          text = Vue.i18n.translate('TABLE_LINE_LAST_WEEK')
        }
        if (item.dayCount <= 1) {
          text = Vue.i18n.translate('TABLE_LINE_TODAY')
        }
        if (lastGroup !== text) {
          item.diffText = text
          lastGroup = item.diffText
        } else {
          item.diffText = null
        }
      }
      Vue.prototype.$api.hideIdle()
    },
    onChangeTab : function (tab) {
      Vue.prototype.$api.debug('onChangeTab', tab)
    },
    saveEmailNotification: function (item) {
      Vue.prototype.$api.debug('saveEmailNotification', item)
      if (!item.isEmail) {
        item.email = '1'
        this.setEmailNotification(item, true)
      } else {
        item.email = '0'
        this.setEmailNotification(item, false)
      }
    },
    setEmailNotification: function (item, isEmail) {
      Vue.prototype.$api.debug('setEmailNotification', item, isEmail)
      if (isEmail) {
        item.email = '1'
      } else {
        item.email = '0'
      }
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.updateChangeLogs(item, this.onGetUpdate, this.onGetUpdate)
    },
    onGetUpdate (data) {
      Vue.prototype.$api.debug('onGetUpdate')
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    },
    changeSort (column) {
      Vue.prototype.$api.debug('change sort', column)
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    dayDiff (date1, date2) {
      let dayDifference = date1.diff(date2, 'days')
      return dayDifference
    },
    onGetBankData (item) {
      Vue.prototype.$api.debug('onGetBankData', item, this.currentItem)
      Vue.prototype.$api.hideIdle()
      var param = {
        year: '' + this.currentItem.Jahr,
        crefoNr: this.currentItem.CrefoNr,
        bankBalanceDate: item.bilanzDate,
        balanceDate: item.bilanzDate,
        rechtskreis: this.currentItem.RechtskreisNr,
        abschlussart: this.currentItem.AbschlussartNr,
        guid: item.bankID,
        isForwardItem: true,
        hasAnkerbank: false,
        bankCurrency: item.bankCurrency + '',
        currency: item.bankCurrency + '',
        currencyDim: item.bankCurrencyDim + '',
        country: this.currentItem.country,
        region: this.currentItem.region,
        balanceSum: item.bankBalanceSums,
        orderNr: item.orderNr,
        sourceNr: item.sourceNr,
        ultimateMother: item.ultimateMother,
        lastChanged: item.lastChanged,
        name: this.currentItem.name,
        branch: this.currentItem.BranchenkategorieNr
      }
      item.isAnkerbank = true
      Vue.prototype.storage.ankerBank = param
      this.$router.push({name: 'AnkerbankDetails', params: param})
    },
    onSetNotificationDone () {
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    },
    deleteItem (item) {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.setAlertFunction(this, item.CrefoNr, false, this.onSetNotificationDone, this.onSetNotificationDone)
    },
    openItem (item) {
      item['bank'] = item.id
      item['type'] = 'JSON'
      item['year'] = item.Jahr
      item['year'] = item.Jahr
      Vue.prototype.$api.debug('item', item)
      if (item.Aenderungsgrund === '3') {
        return
      }
      this.currentItem = item
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getBankDataByTriple(item, this.onGetBankData, Vue.prototype.$api.onFailure)
    },
    getValue (item, _header) {
      var value = item[_header.value]
      if (_header.value === 'RechtskreisNr') {
        var e = Vue.prototype.$api.getI18NRechtsKreis(item.RechtskreisNr)
        if (e) value = e.title
      }
      if (_header.value === 'Aenderungsgrund') {
        e = Vue.prototype.$api.getI18NAenderungsgrund(item.Aenderungsgrund)
        if (e) value = e.title
      }
      if (_header.value === 'QuelleNr') {
        e = Vue.prototype.$api.getI18NQuelle(item.QuelleNr)
        if (e) value = e.lanValue
      }
      if (_header.value === 'branch') {
        e = Vue.prototype.$api.getI18NBranche(item.branch)
        if (e) value = e.title
      }
      if (_header.value === 'country') {
        e = Vue.prototype.$api.getI18NCountry(item.country)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'region') {
        e = Vue.prototype.$api.getI18NRegion(item.region)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'datumZeit') {
        if (value) {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }
      if (_header.value === 'AbschlussartNr') {
        e = Vue.prototype.$api.getI18NAbschlussart(item.AbschlussartNr)
        if (e) value = e.title
      }
      if (_header.value === 'balanceSum') {
        if (!Number.isFinite(value)) {
          var maximumFractionDigits = 2
          var minimumFractionDigits = 2
          value = (1 * value).toLocaleString('de-DE', {
            style: 'decimal',
            useGrouping: true,
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits
          })
        }
      }
      if (item.isAnkerBank) {
        var v = value
        if (!v) v = ''
        return '<b>' + v + '</b>'
      }
      return value
    },
    getHeaderClass (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    getClassFor (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    onChangeLogs: function () {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getChangeLogs(this.onGetChangelogs, this.onGetChangelogs)
      Vue.prototype.$api.getChangeLogBL(this.onGetChangelogBL, this.onGetChangelogs)
    }
  },
  mounted () {
    var cmp = this
    cmp.onChangeLogs()

    if (Vue.prototype.$api.getParamData().clientNr === '361') {
      this.headers = [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_HGPNR'), value: 'hgpNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_ABSCHLUSS'), value: 'AbschlussartNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_RECHTSKREIS'), value: 'RechtskreisNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_JAHR'), value: 'Jahr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_QUELLE'), value: 'QuelleNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_DATUM'), value: 'datumZeit', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_GRUND'), value: 'Aenderungsgrund', sortable: false}
      ]
      // Favoriten Liste
      this.headersBL = [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_HGPNR'), value: 'hgpNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_REGION'), value: 'region', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_LAND'), value: 'country', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_DATE_ADDED'), value: 'datumZeit', sortable: false},
        /* { text: Vue.i18n.translate('CELL_TITLE_BRANCHE'), value: 'branch', sortable: false }, */
        {text: Vue.i18n.translate('CELL_TITLE_ACTION'), value: 'action', sortable: false}
      ]
    } else {
      this.headers = [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_ABSCHLUSS'), value: 'AbschlussartNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_RECHTSKREIS'), value: 'RechtskreisNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_JAHR'), value: 'Jahr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_QUELLE'), value: 'QuelleNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_DATUM'), value: 'datumZeit', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_GRUND'), value: 'Aenderungsgrund', sortable: false}
      ]
      // Favoriten Liste
      this.headersBL = [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_REGION'), value: 'region', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_LAND'), value: 'country', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_DATE_ADDED'), value: 'datumZeit', sortable: false},
        /* { text: Vue.i18n.translate('CELL_TITLE_BRANCHE'), value: 'branch', sortable: false }, */
        {text: Vue.i18n.translate('CELL_TITLE_ACTION'), value: 'action', sortable: false}
      ]
      this.cellspan = this.headers.length
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/Newsbox.vue